<template>
  <div
    :class="backgroundClass"
    data-ui="stats"
  >
    <div
      v-if="bannerImageSrc"
      class="stats__image"
      data-ui="stats-image"
    >
      <CdrImg
        :alt="alt"
        :src="bannerImageSrc"
        loading="lazy"
      />
    </div>
    <div class="stats__body">
      <div class="stats__header">
        <h2
          class="stats__header-title"
          v-html="statsHeading"
        />
        <p
          class="stats__header-subtitle"
          v-html="statsSubtitle"
        />
      </div>
      <CdrList
        v-if="callouts.length"
        tag="ul"
        class="stats__callouts"
      >
        <li
          v-for="(callout, index) in callouts"
          :key="index"
          v-bind="callout"
          class="stats__list-item"
          :data-analytics-id="`stats-callout_${callout.headings.heading.text}`"
        >
          <CdrImg
            v-if="callout.media.image"
            :src="callout.media.image.src"
            :alt="callout.media.alt"
            loading="lazy"
            class="stats__list-item-image"
          />
          <h5
            class="stats__stat-title"
            v-html="callout.headings.heading.text"
          />
          <p class="stats__stat-subtitle">
            {{ callout.text.subtitle.text }}
          </p>
        </li>
      </CdrList>
    </div>
  </div>
</template>

<script>
import {
  CdrImg,
  CdrList,
} from '@rei/cedar';
import getThemeClass from '../../../../utils/customClass';

export default {
  name: 'StatsComponent',
  components: {
    CdrImg,
    CdrList,
  },
  props: {
    statsHeading: {
      type: String,
      required: true,
    },
    statsSubtitle: {
      type: String,
      required: false,
      default: '',
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
    bannerImageSrc: {
      type: String,
      required: false,
      default: '',
    },
    children: {
      type: Object,
      required: false,
      default() { return {}; },
    },
    theme: {
      type: String,
      required: false,
      default: 'tan',
    },
  },
  computed: {
    callouts() {
      return this.getStatsCalloutsArray(this.children) || [];
    },
    backgroundClass() {
      return {
        stats: true,
        'stats__extra-space': this.bannerImageSrc,
        ...getThemeClass(this.theme, 'section__background'),
      };
    },
  },
  methods: {
    getStatsCalloutsArray(callouts) {
      if (!callouts) return null;

      return Object.keys(callouts).map((id, index) => {
        const payload = { ...callouts[id], index, id };
        delete payload.children;
        return payload;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.stats {
  text-align: center;
  padding: $cdr-space-two-x;
  position: relative;
  @include cdr-sm-mq-up  {
    padding: $cdr-space-three-x;
  }
  @include cdr-md-mq-up  {
    padding: $cdr-space-four-x;
  }
}

.stats__extra-space {
  padding-top: $cdr-space-four-x;
}

.stats__body {
  position: relative;
  max-width: $cdr-breakpoint-lg;
  margin: 0 auto;
}

.stats__image {
  position: absolute;
  top: -85px;
  padding: 50px 0 0 0;
  left: 0;
  max-width: 342px;
  right: 0;
  margin: 0 auto;
  background: #e8e0ce;
  height: 223px;
  border-radius: 100% 100% 0 0;
  overflow: hidden;
  z-index: 0;
  border-radius: 200px 200px 0 0;

  @include cdr-md-mq-only {
    top: -60px;
    padding: 30px 0 0 0;
  }
}

.stats__image img {
  max-width: 157px;

  @include cdr-md-mq-only{
    max-width: 140px;
  }
}
.stats__header-title {
  @include cdr-text-heading-serif-800;
  color: $cdr-color-text-brand;
  margin-bottom: $cdr-space-half-x;
}

.stats__header-subtitle {
  @include cdr-text-heading-sans-400;
}

.stats__stat-title {
  @include cdr-text-heading-serif-700;
  color: $cdr-color-text-brand;
  margin-bottom: $cdr-space-half-x;
}

.stats__stat-subtitle {
  @include cdr-text-utility-sans-strong-300;
  margin-bottom: 0;
}

.stats__callouts {
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: row;
  max-width: 1168px;
  margin: $cdr-space-two-x auto 0;

  @include cdr-sm-mq-up {
    display: flex;
    padding-left: $cdr-space-one-and-a-half-x;
  }
}

.stats__callouts .stats__list-item {
  margin-top: 0;
  margin-bottom: $cdr-space-two-x;

  @include cdr-sm-mq-up {
    max-width: 235px;
  }

  @include cdr-md-mq-up {
    max-width: unset;
  }

  &:last-child {
    margin-bottom: 0;
  }
  @include cdr-sm-mq-up  {
    margin-bottom: 0;
  }
}

.stats__list-item-image {
  max-height: 120px;
}

</style>
